export default "__VITE_ASSET__a228133a__"